import { isModernBridge } from '@/common/bridge/mode';

import * as CommsService from '../comms.service';
import { CommsCommand } from '../comms.enum';

/**
 * Emit the `on_chat:start` event to the host page when a live chat session becomes
 * active. No-op outside modern SDK bridge mode.
 */
export function emitChatStart(): void {
  if (!isModernBridge()) {
    return;
  }

  CommsService.post(CommsCommand.emit.chatStart);
}
